import React, { useState, useEffect } from 'react';
import {
  Box, Grid, Card, CardContent, Typography,
  Button, Dialog, DialogActions, DialogContent,
  DialogTitle, IconButton, CircularProgress
} from '@mui/material';
import { Link } from 'react-router-dom';
import FarmForm from './FarmForm';
import { Close } from '@mui/icons-material';
import axios from 'axios';

const FarmList = () => {
  const [farms, setFarms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);

  const fetchFarms = async () => {
    try {
      const response = await axios.get('https://sense-agro-backend.onrender.com/api/fazendas');
      if (Array.isArray(response.data)) {
        setFarms(response.data);
      } else {
        console.warn("Resposta inesperada:", response.data);
        setFarms([]);
      }
    } catch (error) {
      console.error("Erro ao buscar fazendas:", error);
      setFarms([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveFarm = () => {
    handleCloseDialog();
    fetchFarms(); // Recarrega a lista com a nova fazenda
  };

  useEffect(() => {
    fetchFarms();
  }, []);

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4" gutterBottom>Fazendas Cadastradas</Typography>

      <Button variant="contained" color="primary" sx={{ marginBottom: 2 }} onClick={handleOpenDialog}>
        Cadastrar Fazenda
      </Button>

      {loading ? (
        <CircularProgress />
      ) : (
        <Grid container spacing={3}>
          {farms.length === 0 ? (
            <Typography variant="body1">Nenhuma fazenda cadastrada ainda.</Typography>
          ) : (
            farms.map((farm) => (
              farm && (
                <Grid item xs={12} sm={6} md={4} key={farm.id}>
                  <Card sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <CardContent sx={{ flex: 1 }}>
                      <Typography variant="h6">{farm.nome}</Typography>
                      <Typography variant="body2" color="textSecondary">
                        {farm.endereco || 'Endereço não informado'}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Cultura: {farm.culturaPrincipal || 'N/A'}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Hectares: {farm.hectaresTotal || 0}
                      </Typography>
                    </CardContent>
                    <Button
                      component={Link}
                      to={`/farm/${farm.id}`}
                      variant="contained"
                      color="primary"
                      sx={{ margin: 2 }}
                    >
                      Ver Detalhes
                    </Button>
                  </Card>
                </Grid>
              )
            ))
          )}
        </Grid>
      )}

      <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="md">
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Cadastrar Fazenda
          <IconButton edge="end" onClick={handleCloseDialog} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <FarmForm onSave={handleSaveFarm} onCancel={handleCloseDialog} />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default FarmList;
